import { SystemField } from "./system-field";

export class SaleTransactionCount extends SystemField {
     
     order_type?:string;
     qty?:number;
     total_amount?:number;
     staff_shifts_id?:string;
     transaction_date?:string;
     channel?:string;
}
